import {
  GESTION_OPERATIVA_GET_CLIENTE_BEGIN,
  GESTION_OPERATIVA_GET_CLIENTE_SUCCESS,
  GESTION_OPERATIVA_GET_CLIENTE_FAILURE,
  GESTION_OPERATIVA_GET_CLIENTE_DISMISS_ERROR,
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'

export function getCliente(id) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: GESTION_OPERATIVA_GET_CLIENTE_BEGIN,
      data: {
        client_id: id,
      },
    })
    const promise = new Promise((resolve, reject) => {
      const doRequest = BFFAgent.Clients.getCliente(id)
      doRequest.then(
        (cliente) => {
          dispatch({
            type: GESTION_OPERATIVA_GET_CLIENTE_SUCCESS,
            data: cliente,
          })
          resolve(cliente)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: GESTION_OPERATIVA_GET_CLIENTE_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetClienteError() {
  return {
    type: GESTION_OPERATIVA_GET_CLIENTE_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_GET_CLIENTE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getClientePending: true,
        getClienteError: null,
        client_id: action.data.client_id,
        cliente: null,
      }

    case GESTION_OPERATIVA_GET_CLIENTE_SUCCESS:
      // The request is success
      return {
        ...state,
        getClientePending: false,
        getClienteError: null,
        cliente: action.data,
      }

    case GESTION_OPERATIVA_GET_CLIENTE_FAILURE:
      // The request is failed
      return {
        ...state,
        getClientePending: false,
        getClienteError: action.data.error,
        client_id: null,
        cliente: null,
      }

    case GESTION_OPERATIVA_GET_CLIENTE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getClienteError: null,
      }

    default:
      return state
  }
}
